import styled from 'styled-components';
import { colour, media, spacing } from '../../../../theme';

export const PaymentMethodsContainer = styled.div`
    margin-top: ${spacing.spacing7};
`;

export const PaymentOptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${spacing.spacing3} ${spacing.spacing2};
    margin-bottom: ${spacing.spacing5};
    color: ${colour.palette.greyscale80};
    background-color: ${colour.palette.greyscale5};
    width: 100%;
    max-width: 100%;
    gap: ${spacing.spacing4};

    & svg {
        width: 100%;
    }

    & p {
        margin: 0;
    }

    @media ${media.small} {
        width: 864px;
        padding: calc(${spacing.spacing6} - 2px) ${spacing.spacing5};
        flex-direction: row;
        gap: ${spacing.spacing7};

        svg {
            width: 364px;
            height: 50px;
        }
    }
`;

export const PaymentContainer = styled.div`
    width: 62%;
`;

export const NoteContainer = styled.div`
    max-width: 690px;
`;

export const ItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const LineItemContainer = styled.div`
    display: flex;
`;

export const OrderGroupContainer = styled.div`
    border-bottom: 1px solid ${colour.palette.greyscale5};
    padding-bottom: ${spacing.spacing5};
`;
export const OrderGroupContainerLastEntry = styled.div`
    padding-bottom: ${spacing.spacing5};
`;
